module.exports = __webpack_public_path__ + "img/spin_btn.1eba635e.png";